import React from "react";

// Editable eyebrow + title for each homepage section. Values live in settings as sec_<key>_eyebrow / sec_<key>_title.
export const SECTION_HEADINGS = [
  { key: "batches", label: "Programs (batches)", eyebrow: "Programs", title: "A class for every age." },
  { key: "competition", label: "Competition crews", eyebrow: "Competition team", title: "Train to compete." },
  { key: "events", label: "Events", eyebrow: "Happening now", title: "Events." },
  { key: "why", label: "Why parents choose us", eyebrow: "Why parents choose us", title: "More than dance. A confidence engine." },
  { key: "achievements", label: "Recent accolades", eyebrow: "Recent accolades", title: "On stage. On podium." },
  { key: "workshops", label: "Workshops", eyebrow: "What's next", title: "Upcoming workshops." },
  { key: "reviews", label: "Google reviews", eyebrow: "From Google", title: "What families say." },
  { key: "hire", label: "Hire us", eyebrow: "Book us for your event", title: "Hire us." },
  { key: "gallery", label: "Gallery (Moments)", eyebrow: "On stage", title: "Moments." },
  { key: "reels", label: "Instagram reels", eyebrow: "Follow along", title: "Latest reels." },
];

const inp = "w-full bg-black border border-white/10 px-3 py-2 text-sm focus:border-red-600 outline-none";

export default function SectionHeadings({ settings, setField }) {
  return (
    <div className="card-surface p-6" data-testid="section-headings">
      <div className="eyebrow mb-1">Section headings</div>
      <p className="text-zinc-500 text-xs mb-5">Small red label (eyebrow) and the big title shown above each homepage section. Leave blank to use the default shown in grey.</p>
      <div className="divide-y divide-white/5">
        {SECTION_HEADINGS.map(s => (
          <div key={s.key} className="py-4 grid sm:grid-cols-[180px_1fr_1.4fr] gap-3 items-start" data-testid={`heading-row-${s.key}`}>
            <div className="text-sm font-semibold pt-2">{s.label}</div>
            <div>
              <label className="eyebrow block mb-1 text-[9px]">Eyebrow</label>
              <input value={settings[`sec_${s.key}_eyebrow`] ?? ""} placeholder={s.eyebrow} onChange={e => setField(`sec_${s.key}_eyebrow`, e.target.value)} className={inp} data-testid={`heading-eyebrow-${s.key}`} />
            </div>
            <div>
              <label className="eyebrow block mb-1 text-[9px]">Title</label>
              <input value={settings[`sec_${s.key}_title`] ?? ""} placeholder={s.title} onChange={e => setField(`sec_${s.key}_title`, e.target.value)} className={inp} data-testid={`heading-title-${s.key}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
